<template>
  <div>
    <div class="content-title">充值</div>
    <div class="content-tool" style="width: 500px;">
      <el-form
        :model="addrecharge"
        :rules="rules"
        ref="addrecharge"
        label-width="120px"
      >
        <el-form-item label="付款人：" prop="payName">
          <el-input v-model="addrecharge.payName"></el-input>
        </el-form-item>
        <el-form-item label="付款账户：" prop="payAccount">
          <el-input v-model="addrecharge.payAccount"></el-input>
        </el-form-item>
        <el-form-item label="收款人：" prop="recvName">
          <el-input disabled v-model="addrecharge.recvName"></el-input>
        </el-form-item>
        <el-form-item label="收款账户：" prop="recvAccount">
          <el-input v-model="addrecharge.recvAccount"></el-input>
        </el-form-item>
        <el-form-item label="收款银行：" prop="recvAccount">
          <el-input disabled v-model="addrecharge.recvBank"></el-input>
        </el-form-item>
        <el-form-item label="转账金额：" prop="money">
          <el-input-number
            v-model="addrecharge.money"
            :precision="2"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="付款日期：" prop="payDate">
          <el-date-picker
            v-model="addrecharge.payDate"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上传回单：">
          <el-upload
            class="my-el-button-reset"
            ref="elupload"
            action=""
            accept=".png,.jpg,.jpeg,.gif,.bmp"
            :limit="1"
            :show-file-list="false"
            :http-request="uploadFile"
          >
            <el-button size="medium">+ 添加回单文件</el-button>
          </el-upload>
          <div class="img-box" v-if="addrecharge.fileUrl != null">
            <el-image
              :src="addrecharge.fileUrl"
              style="width: 100px; height: 100px"
            ></el-image>
            <i
              class="el-icon-circle-close"
              title="删除图片"
              @click="addrecharge.fileUrl = null"
            ></i>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addRecharge">提&nbsp;交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
import { Loading } from 'element-ui';
// import { parseTime } from '@/utils';

export default {
  name: 'addrecharge',
  data() {
    return {
      addrecharge: {
        payName: null,
        payAccount: null,
        recvName: '萍乡市迅果科技有限公司',
        recvAccount: '574908432410606',
        // recvName: '江西迅启启丰信息科技有限公司',
        // recvAccount: '8110801012501983348',
        recvBank: '招商银行上海金沙江路支行',
        payDate: null,
        money: 0.0,
        fileUrl: null,
      },
      rules: {
        payName: [{ required: true, message: '请输入付款人', trigger: 'blur' }],
        payAccount: [
          { required: true, message: '请输入付款账号', trigger: 'blur' },
        ],
        recvName: [
          { required: true, message: '请输入收款人', trigger: 'blur' },
        ],
        recvAccount: [
          { required: true, message: '请输入收款账号', trigger: 'blur' },
        ],
        payDate: [
          { required: true, message: '请设置转账日期', trigger: 'change' },
        ],
        money: [
          { required: true, validator: this.moneyValidator, trigger: 'change' },
        ],
        // fileUrl: [{ required: true, validator: this.fileValidator, trigger: 'change' }],
      },
    };
  },
  mounted() {
    if (this.$store.state.plat === 1) {
      this.addrecharge.recvName = '萍乡市迅果科技有限公司';
      this.addrecharge.recvAccount = '574908432410606';
    } else if (this.$store.state.plat === 2) {
      this.addrecharge.recvName = '江西迅启启丰信息科技有限公司';
      this.addrecharge.recvAccount = '574908432410606';
    }
    this.fetchProviderDetail();
  },
  methods: {
    uploadFile(param) {
      const eleLoading = Loading.service({
        lock: true,
        text: '文件正在上传中...',
        spinner: 'el-icon-loading',
        background: '(0,0%,100%,.9)',
      });
      // 现代浏览器导入
      const fileObj = param.file;
      const formData = new FormData();
      const fileTypeReg = /\.(png|jpg|pdf)$/gi;
      formData.append('file', fileObj);
      formData.append('fileName', fileObj.name);

      // 校验满足条件的文件
      if (!fileTypeReg.test(fileObj.name)) {
        eleLoading.close();
        this.$message.error('请选择 excel 文件上传');
        return;
      }
      if (fileObj.length > 1) {
        eleLoading.close();
        this.$message.error('最多上传一个文件');
        return;
      }

      const params = {
        data: formData,
      };
      api
        .uploadReceipt({ params })
        .then((result) => {
          eleLoading.close();
          console.log(result);
          this.addrecharge.fileUrl = result;
          console.log('addrecharge', this.addrecharge);
          this.$message({
            message: '上传成功',
            type: 'success',
          });
        })
        .catch(() => {
          eleLoading.close();
          this.$message({
            message: '导入失败，请稍后重试',
            type: 'error',
          });
        });
    },
    addRecharge() {
      this.$refs.addrecharge.validate((valid) => {
        if (!valid) {
          return;
        }
        api
          .addRecharge({
            params: {
              data: this.addrecharge,
            },
          })
          .then(() => {
            this.$message({
              type: 'success',
              message: '新增成功',
            });
            this.$router.go(-1);
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              type: 'error',
              message: err.response.message,
            });
          });
      });
    },
    fetchProviderDetail() {
      api
        .fetchProviderDetail()
        .then((res) => {
          console.log(res);
          if (!res) {
            return;
          }
          this.addrecharge.payName = res.providerName;
          this.addrecharge.payAccount = res.bankAccount;
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.response.message,
          });
        });
    },
    moneyValidator(rule, value, callback) {
      console.log('money: ', this.addrecharge.money, value);
      if (!this.addrecharge.money || this.addrecharge.money === 0.0) {
        callback(new Error('请输入转账金额'));
      } else {
        callback();
      }
    },
    fileValidator(rule, value, callback) {
      if (!this.addrecharge.fileUrl) {
        callback(new Error('请上传转账回执'));
      } else {
        callback();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-title {
  font-size: 18px;
  margin: 10px 20px 20px 20px;
}

.content-tool {
  // padding: 27px 17px 20px 17px;
  // border: 1px solid #ebeef5;
  background: #fff;
  font-size: 15px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.img-box {
  position: relative;
  display: block;
  font-size: 0;
  width: 100px;
  height: 100px;
  margin: 15px 10px 10px 0px;
  img {
    display: block;
    width: 80px;
    height: 80px;
    object-fit: cover;
  }
  i {
    position: absolute;
    width: 25px;
    height: 20px;
    font-size: 25px;
    right: -12px;
    top: -12px;
    background: #fff;
    cursor: pointer;
    color: #999;
    border-radius: 50%;
    text-align: center;
    line-height: 25px;
  }
}
.content-tool--operate {
  padding: 0px 17px 20px 17px;
  margin: 0px 20px 20px 20px;
}
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/addrecharge.vue